export default __webpack_public_path__ + "static/media/icon-admin.65786d3b.svg";